import { render } from "./PersonItem.vue?vue&type=template&id=560f9e3e"
import script from "./PersonItem.vue?vue&type=script&lang=js"
export * from "./PersonItem.vue?vue&type=script&lang=js"

import "./PersonItem.vue?vue&type=style&index=0&id=560f9e3e&lang=scss"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__